<script lang="tsx">
import { computed, defineComponent, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { Table, type TableColumnType } from 'ant-design-vue'
import { genRewardNoResettleColumns, REWARD_NO_RESETTLE_DATA_SOURCE } from '../../tools'
import { calcMulAmount, sumDecimalBy, sumOtherItemsAmount } from '../../calc'
const [name] = createNamespace('GroundAttachCompEntryDisplay')
export default defineComponent({
  name,
  props: {
    data: {
      type: Object as PropType<Partial<ApiJtZch.CompData>>
    },
    standard: {
      type: Object as PropType<Partial<ApiJtProj.CompStandardData>>
    }
  },
  setup(props, { expose }) {
    /**
     * 单行金额：数量 * 标准
     */
    const getRowTotal = (key: string) => calcMulAmount(props.data?.[key], props.standard?.[key])

    const totalAmount = computed(() => {
      // 1) 主表：按“数量 * 标准”累计
      const part1 = sumDecimalBy(REWARD_NO_RESETTLE_DATA_SOURCE, record => getRowTotal(record.key))
      // 2) 其他项：直接累加金额字段 value
      const part2 = sumOtherItemsAmount(props.data?.others)
      return part1.add(part2)
    })
    const mainColumns: TableColumnType[] = [
      ...genRewardNoResettleColumns(),
      {
        title: '标准(元/单位)',
        dataIndex: 'standard',
        width: 200,
        customRender({ record }) {
          return props.standard?.[record.key]
        }
      },
      {
        title: '数量',
        dataIndex: 'count',
        width: 150,
        customRender({ record }) {
          return props.data?.[record.key]
        }
      },
      {
        title: '金额(元)',
        dataIndex: 'total',
        width: 150,
        customRender({ record }) {
          return getRowTotal(record.key).toFixed(2)
        }
      }
    ]

    const renderMainTable = () => (
      <Table pagination={false} columns={mainColumns} dataSource={REWARD_NO_RESETTLE_DATA_SOURCE} size='small' class='ant-calc-table' />
    )

    const otherColumns: TableColumnType[] = [
      {
        title: '项目名称',
        dataIndex: 'group',
        width: 200,
        customRender() {
          return '其他'
        },
        customCell(_, rowIndex) {
          // “其他”作为同组表头：合并成一个单元格（rowSpan）
          if (rowIndex === 0) {
            const othersCount = props.data?.others?.length || 0
            return {
              rowSpan: othersCount > 0 ? othersCount : 1
            }
          }
          return {
            rowSpan: 0
          }
        }
      },
      {
        title: '类别',
        dataIndex: 'label',
        minWidth: 200
      },
      {
        title: '金额(元)',
        dataIndex: 'value',
        width: 150
      }
    ]
    const renderOtherTable = () => (
      <div class='mt-24'>
        <Table pagination={false} columns={otherColumns} dataSource={props.data?.others} size='small' class='ant-calc-table' />
      </div>
    )

    const renderAmount = () => {
      return <div class='amount-tip mt-24'>小计金额：{totalAmount.value.toFixed(2)} 元</div>
    }
    expose({
      totalAmount
    })
    return () => (
      <div>
        {renderMainTable()}
        {renderOtherTable()}
        {renderAmount()}
      </div>
    )
  }
})
</script>
<style lang="less" scoped>
.amount-tip {
  padding: @padding-md @padding-sm;
  color: @primary-color;
  font-weight: bold;
  background: @bg-fade-1;
}
</style>
